module.exports = __webpack_public_path__ + "static/media/icon-error.fcf8d649aec0fa950f1fced1f5da3afb.svg";